import { PhotographIcon } from "@heroicons/react/outline";
import { useState } from "react";

interface DropZoneProps {
  isLoading: boolean;
  onDrop: (file: File) => void;
  onClick: () => void;
  children: React.ReactNode;
  uploadIcon?: React.ElementType;
}

const getDropZoneClassName = (isLoading: boolean, isDragging: boolean): string => {
  if (isLoading) {
    return "cursor-wait border-gray-300";
  }

  if (isDragging) {
    return "border-blue-500 bg-blue-50";
  }

  return "cursor-pointer border-gray-300 hover:border-gray-400";
};

const DropZone = ({
  isLoading,
  onDrop,
  onClick,
  children,
  uploadIcon: UploadIcon,
}: DropZoneProps) => {
  const [isDragging, setIsDragging] = useState(false);

  return (
    <div
      className={`flex h-10 w-full items-center justify-center rounded-lg border border-dashed bg-white px-2 transition-colors ${getDropZoneClassName(isLoading, isDragging)}`}
      onDrop={e => {
        e.preventDefault();
        setIsDragging(false);
        if (!isLoading) {
          onDrop(e.dataTransfer.files[0]);
        }
      }}
      onDragOver={e => {
        e.preventDefault();
        if (!isLoading && !isDragging) {
          setIsDragging(true);
        }
      }}
      onDragLeave={() => setIsDragging(false)}
      onClick={onClick}
    >
      {children}
      {UploadIcon ? (
        <UploadIcon className={`ml-2 h-5 w-5 ${isDragging ? "text-blue-500" : "text-gray-400"}`} />
      ) : (
        <PhotographIcon
          className={`ml-2 h-5 w-5 ${isDragging ? "text-blue-500" : "text-gray-400"}`}
        />
      )}
    </div>
  );
};

export default DropZone;
